// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { isWithinMinMaxVals } from 'validators/common'
import { numericalValuesOnly } from 'helpers/regex'

import {
  INVALID_INPUT,
  REQUIRED,
} from 'errors'

import {
  ELEVATION_SI_BOUNDS,
  ELEVATION_US_BOUNDS,
} from './errors'

const validateElevation = (value, error, unitType, notRequired) => {
  // if the value's not required and the value's an empty string,
  // don't run any validation checks
  if (notRequired && !value) {
    return
  }

  if (!value && value !== 0) {
    error.elevation = REQUIRED
  } else if (value.toString().match(numericalValuesOnly) === null) {
    error.elevation = INVALID_INPUT
  } else if (unitType === 'SI' && !isWithinMinMaxVals(value, -304.495, 30479.695)) {
    error.elevation = ELEVATION_SI_BOUNDS
  } else if (unitType === 'US' && !isWithinMinMaxVals(value, -999, 99999)) {
    error.elevation = ELEVATION_US_BOUNDS
  }
}

export default validateElevation
